import { ratio } from "../utils/index.js";

function computeMasonryLayout(photos, spacing, padding, containerWidth, columns) {
  var columnWidth = (containerWidth - spacing * (columns - 1) - 2 * padding * columns) / columns;

  if (columnWidth <= 0) {
    return columns > 1 ? computeMasonryLayout(photos, spacing, padding, containerWidth, columns - 1) : void 0;
  }

  var columnsCurrentTopPositions = [];

  for (var i = 0; i < columns; i += 1) {
    columnsCurrentTopPositions[i] = 0;
  }

  var columnsModel = photos.reduce(function (model, photo, index) {
    var shortestColumn = columnsCurrentTopPositions.reduce(function (currentShortestColumn, item, i) {
      return item < columnsCurrentTopPositions[currentShortestColumn] - 1 ? i : currentShortestColumn;
    }, 0);
    columnsCurrentTopPositions[shortestColumn] = columnsCurrentTopPositions[shortestColumn] + columnWidth / ratio(photo) + spacing + 2 * padding;
    model[shortestColumn].push({
      photo: photo,
      index: index
    });
    return model;
  }, Array.from({
    length: columns
  }, function () {
    return [];
  }));
  return {
    spacing: spacing,
    padding: padding,
    containerWidth: containerWidth,
    variables: {
      columns: columns
    },
    tracks: columnsModel.map(function (column) {
      return {
        photos: column.map(function (_ref) {
          var photo = _ref.photo,
              index = _ref.index;
          return {
            photo: photo,
            index: index,
            width: columnWidth,
            height: columnWidth / ratio(photo)
          };
        })
      };
    })
  };
}

export { computeMasonryLayout as default };